import { createApi } from '@reduxjs/toolkit/query/react';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query/react';

import { baseQueryWithAuth } from '../auth';
import { APIVersion } from '../../constants/keys';
import { NotificationPlatform, NotificationSubscriptionApi } from '../../types/notifications';

const transformErrorResponse = (response: FetchBaseQueryError) => response;

interface CreateTokenArgs {
  platform: NotificationPlatform;
  token: string;
  timezone: string;
}

interface UpdateTokenArgs extends CreateTokenArgs {
  id: string;
}

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createToken: builder.mutation<NotificationSubscriptionApi, CreateTokenArgs>({
      query: ({ platform, token, timezone }) => ({
        url: `/core-api/${APIVersion}/notification-subscriptions`,
        method: 'POST',
        body: { platform, token, timezone },
      }),
      transformErrorResponse,
    }),
    updateToken: builder.mutation<NotificationSubscriptionApi, UpdateTokenArgs>({
      query: ({ platform, token, timezone, id }) => ({
        url: `/core-api/${APIVersion}/notification-subscriptions/${id}`,
        method: 'PATCH',
        body: { platform, token, timezone },
      }),
      transformErrorResponse,
    }),
  }),
});

export const { useCreateTokenMutation, useUpdateTokenMutation } = notificationsApi;
